<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>科技成果奖励绩效点</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn color="primary" class="ml-3" @click.native.stop="onNewItem">新建</v-btn>
      <v-dialog v-model="dialog" max-width="700px">
        <v-card>
          <v-form v-model="dialogValid" ref="form" lazy-validation>
            <v-card-title>
              <span class="subheading">{{formTitle}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs6>
                  <v-select
                    label="奖励版本名称"
                    item-text="name"
                    item-value="dbid"
                    autocomplete
                    clearable
                    required
                    :rules="rules.versionId"
                    :loading="versionLoading"
                    :items="versionItems"
                    :search-input.sync="versionSearch"
                    v-model="editedItem.versionId"
                    v-on:keyup.enter="onVersionSearch"
                    :append-icon-cb="onVersionSearch"
                    hint="输入关键词检索"
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs6>
                    <v-select
                      label="奖励类型名称"
                      item-text="name"
                      item-value="dbid"
                      autocomplete
                      clearable
                      required
                      :rules="rules.typeId"
                      :loading="typeLoading"
                      :items="typeItems"
                      :search-input.sync="typeSearch"
                      v-model="editedItem.typeId"
                      v-on:keyup.enter="onTypeSearch"
                      :append-icon-cb="onTypeSearch"
                      hint="输入关键词检索"
                      persistent-hint
                    />
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field label="绩点（单位：项）" required :rules="rules.score" v-model="editedItem.score"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="blue darken-1" flat @click.native="clear">取消</v-btn>
              <v-btn color="primary"
                     :disabled="!dialogValid"
                     @click.native="save">保存
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-spacer/>
      <v-spacer/>
      <v-text-field
        append-icon="search"
        label="按名称检索…"
        v-model="search"
      />
    </v-toolbar>
    <v-divider/>
    <v-data-table
      :headers="headers"
      :search="search"
      :loading="loading"
      :total-items="total"
      :pagination.sync="pagination"
      item-key="dbid"
      :items="items"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.version.name }}</td>
        <td>{{ props.item.number}}</td>
        <td>{{ props.item.type.name}}</td>
        <td>{{ props.item.score }}</td>
        <td>{{stateMap[props.item.flag]}}</td>
        <td class="justify-center layout px-0">
          <v-tooltip top>
            <v-btn icon class="mx-0"
                   slot="activator" @click="onEditItem(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
            <span>编辑</span>
          </v-tooltip>
          <v-tooltip top>
            <v-btn icon class="mx-0"
                   slot="activator" @click="onConfirmDeleteItem(props.item)">
              <v-icon color="pink">delete</v-icon>
            </v-btn>
            <span>删除</span>
          </v-tooltip>
        </td>
      </template>
      <!--<template slot="pageText" slot-scope="props">-->
      <!--显示第 {{props.pageStart}} - {{props.pageStop}} 条记录，共 {{props.itemsLength}} 条记录。-->
      <!--</template>-->
    </v-data-table>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span>确定要删除该条目吗？</span>
        </v-card-title>
        <v-card-text class="headline">
          {{deleteText}}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click.stop="dialogDelete=false">取消</v-btn>
          <v-btn color="primary" flat @click.stop="onDeleteItem">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        // 期刊表格
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '版本名称', align: 'left', sortable: true, value: 'version'},
          {text: '版本号', align: 'left', sortable: true, value: 'number'},
          {text: '奖励类型', align: 'left', sortable: true, value: 'type'},
          {text: '绩效点', align: 'left', sortable: false, value: 'score'},
          {text: '有效标识', align: 'left', sortable: false, value: 'flag'},
          {text: '操作', align: 'center', sortable: false, value: 'dbid'}
        ],
        stateMap: {
          yes: "有效",
          no: "无效"
        },
        loading: false,
        total: 0,
        pagination: {},
        items: [],

        //版本号
        versionLoading: false,
        versionItems: [],
        versionSearch: "",

        //类型名称
        typeLoading: false,
        typeItems: [],
        typeSearch: "",

        // 检索框
        search: '',
        searchKey: 'name',

        // 编辑对话框
        dialog: false,
        dialogValid: true,
        editedIndex: -1,
        editedItem: {
          "versionId":"",
          "version": "",
          "number": "",
          "typeId":"",
          "type":"",
          "score":"",
          "flag": ""
        },
        defaultItem: {
          "versionId":"",
          "version": "",
          "number": "",
          "typeId":"",
          "type":"",
          "score":"",
          "flag": ""
        },
        rules: {
          versionId: [
            v => !!v || '必填项。'
          ],
          typeId: [
            v => !!v || '必填项。'
          ],
          score:[
            v => !!v || '必填项。'
          ]
        },

        // 删除对话框
        dialogDelete: false,
        deleteLoading: false,
        deleteIndex: -1,
        deleteDbid: '',
        deleteText: ''
      }
    },
    created() {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'get',
      pagination: {
        handler: 'get',
        deep: true
      }
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? '新建' : '编辑'
      }
    },
    methods: {
      paginationParams(p) {
        let params = {};
        if (p.sortBy) {
          params.sort = p.sortBy + (p.descending ? '.desc' : '.asc')
        }
        if (p.page) {
          params.page = p.page - 1
        }
        if (p.rowsPerPage) {
          params.limit = p.rowsPerPage
        }
        return params;
      },
      searchParams(k, v) {
        v = v.trim();
        let params = {};
        if (k && v.length > 0) {
          params[k] = v;
        }
        return params;
      },
      //检索版本
      onVersionSearch() {
        let params = {};
        if (this.versionSearch) {
          const val = this.versionSearch.trim();
          if (val.length > 0) {
            params["name"] = val;
          }
        }
        const vm = this;
        vm.versionLoading = true;
        this.axios.get('/api/perf/Version', {params: params}).then(
          rsp => {
            vm.versionLoading = false;
            vm.versionItems = rsp.data.items;
          })
      },
      //检索类型
      onTypeSearch() {
        let params = {};
        if (this.typeSearch) {
          const val = this.typeSearch.trim();
          if (val.length > 0) {
            params["name"] = val;
          }
        }
        const vm = this;
        vm.typeLoading = true;
        this.axios.get('/api/perf/awardLevel', {params: params}).then(
          rsp => {
            vm.typeLoading = false;
            vm.typeItems = rsp.data.items;
          })
      },
      // diff(trg,src){
      //   Object.keys(trg).map()
      // },
      save() {
        window.console.debug("SAVE");
        // todo, only submit modified fields
        if (this.$refs.form.validate()) {
          if (this.editedIndex < 0) {
            this.post(this.editedItem)
          } else {
            this.put(this.items[this.editedIndex].dbid, this.editedItem)
          }
        }
      },
      clear() {
        this.dialog = false;
        this.$refs.form.reset()
      },
      post(data) {
        const vm = this;
        this.axios.post('/api/perf/awardLevelScore', data).then((rsp) => {
          vm.items.unshift(rsp.data);
          vm.total = vm.total + 1;
          vm.dialog = false;
        })
      },
      put(dbid, data) {
        const vm = this;
        this.axios.put('/api/perf/awardLevelScore/' + dbid, data).then((rsp) => {
          vm.items[vm.editedIndex] = rsp.data;
          vm.dialog = false;
        })
      },
      get() {
        window.console.debug("GET");
        const vm = this;
        vm.loading = true;
        const params = Object.assign(
          this.paginationParams(vm.pagination), this.searchParams(vm.searchKey, vm.search)
        );
        this.axios.get('/api/perf/awardLevelScore', {
          params: params
        }).then((rsp) => {
          vm.loading = false;
          vm.items = rsp.data.items.map(
            v => {
              return v;
            });
          vm.total = rsp.data.total;
        })
      },
      onNewItem() {
        this.editedIndex = -1;
        this.editedItem = Object.assign({}, this.defaultItem);
        //this.defaultItem = {};
        this.$refs.form.reset();
        this.dialog = true
      },
      onEditItem(item) {
        this.editedIndex = this.items.indexOf(item);
        this.editedItem = Object.assign({}, item);
        // 填充编辑对话框
        this.versionItems = item.version ? [item.version] : [];
        this.typeItems = item.type ? [item.type] : [];
        //this.defaultItem = Object.assign({}, item);
        this.dialog = true
      },
      onConfirmDeleteItem(item) {
        this.deleteText = item.name;
        this.deleteDbid = item.dbid;
        this.deleteIndex = this.items.indexOf(item);
        this.dialogDelete = true;
      },
      onDeleteItem() {
        const vm = this;
        vm.deleteLoading = true;
        this.axios.delete('/api/perf/awardLevelScore/' + vm.deleteDbid).then(() => {
          this.items.splice(vm.deleteIndex, 1);
          this.total = this.total - 1;
          this.deleteIndex = -1;
          this.dialogDelete = false;
        })
      }
    }
  }
</script>
<style scoped>
  div.toolbar__content div.input-group {
    margin-left: 1em;
  }
</style>
